import { createContext } from 'react';

export const DesignerLayoutContext = createContext(
    {
        "hasLayout":false
    }
);